// スマホの商品ページの固定カートボタン(snippets/sticky-atc.liquid)
// 本来のカートボタンが画面の外(下にあるとき=開いた直後、上に流れたとき)のあいだだけ出し、押したら本来のボタンを押す。価格と売り切れはその都度読み直す
(function () {
  const bar = document.querySelector('.sticky-atc');
  const main = document.querySelector('product-form form button[name="add"]');
  if (!bar || !main) return;
  const button = bar.querySelector('.sticky-atc__button');

  const priceText = () => {
    const price = document.querySelector('.product__info-container .price');
    if (!price) return '';
    const el = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--last')
      : price.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim() : '';
  };

  const refresh = () => {
    const soldOut = main.disabled;
    button.disabled = soldOut;
    const label = soldOut ? 'Sold out' : `Add to cart — ${priceText()}`;
    if (button.textContent !== label) button.textContent = label;
  };

  let ticking = false;
  const update = () => {
    ticking = false;
    const rect = main.getBoundingClientRect();
    const show = rect.bottom < 0 || rect.top > window.innerHeight;
    if (bar.hidden === show) {
      bar.hidden = !show;
      if (show) refresh();
    }
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  update();

  button.addEventListener('click', () => main.click());
})();
